import { Injectable } from '@angular/core';
import {
	AccountInfoModel,
	UpdateAccountModel,
	UserModel
} from '@twrx-api-models';
import { Observable } from 'rxjs';

import { ProfileRoutes } from '../api-routes';
import { HttpApiService } from '../base/http-api.service';
import { BaseApiCRUDService } from '../base/base-api-crud-service';

@Injectable()
export class ProfileApiService extends BaseApiCRUDService<
	number,
	void,
	UserModel,
	void,
	UpdateAccountModel,
	void,
	void,
	void
> {
	protected rootRoute: string = ProfileRoutes.Root;

	constructor(protected httpApiService: HttpApiService) {
		super(httpApiService);
	}

	public getCurrentUser(
		cancellationSubject: Observable<void>
	): Observable<UserModel> {
		return this.httpApiService.get<UserModel>(
			this.rootRoute,
			null,
			cancellationSubject
		);
	}

	public getCurrentUserInfo(
		cancellationSubject: Observable<void>
	): Observable<AccountInfoModel> {
		return this.httpApiService.get<AccountInfoModel>(
			`${this.rootRoute}/${ProfileRoutes.Info}`,
			null,
			cancellationSubject
		);
	}
}
